module.exports = __webpack_public_path__ + "img/camera-pink.d2e6e464.svg";